import { cn } from '@/utils/cva';
import { playButtonStyles } from './PlayButton.styles';

interface PlayButtonProps {
  onClick: () => void;
  className?: string;
}

export const PlayButton = ({ onClick, className }: PlayButtonProps) => {
  return (
    <button
      aria-label="Play video"
      className={cn(playButtonStyles(), className)}
      type="button"
      onClick={onClick}
    >
      <svg
        aria-hidden="true"
        className="h-[38px] w-[38px] text-white dark:text-white"
        fill="currentColor"
        height="48"
        viewBox="0 0 22 24"
        width="48"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          clipRule="evenodd"
          d="M8.6 5.2A1 1 0 0 0 7 6v12a1 1 0 0 0 1.6.8l8-6a1 1 0 0 0 0-1.6l-8-6Z"
          fillRule="evenodd"
        />
      </svg>
    </button>
  );
};
